import { type Namespace } from './react'

export function extractKeyFromSelector(
  selector: ($: object) => unknown,
  namespaces: Namespace | readonly Namespace[]
): string {
  const pathSegments: string[] = []
  let capturedNamespace: string | null = null

  const nsArray: readonly Namespace[] = Array.isArray(namespaces) ? namespaces : [namespaces]

  const primaryNamespace = nsArray[0]
  const isSingleNamespace = !Array.isArray(namespaces)

  const createProxy = (): object =>
    new Proxy(
      {},
      {
        get(_, prop: string): unknown {
          if (
            pathSegments.length === 0 &&
            !capturedNamespace &&
            nsArray.includes(prop as Namespace) &&
            prop !== primaryNamespace
          ) {
            capturedNamespace = prop
            return createProxy()
          }

          pathSegments.push(prop)
          return createProxy()
        },
      }
    )

  const proxy = createProxy()
  selector(proxy)

  if (isSingleNamespace) {
    return `${namespaces as Namespace}:${pathSegments.join('.')}`
  }

  const ns = capturedNamespace ?? primaryNamespace
  return `${ns}:${pathSegments.join('.')}`
}

export function parseNamespacedKey(fullKey: string): {
  ns: string
  key: string
} {
  const colonIndex = fullKey.indexOf(':')

  if (colonIndex === -1) {
    return { ns: 'common', key: fullKey }
  }

  return {
    ns: fullKey.slice(0, colonIndex),
    key: fullKey.slice(colonIndex + 1),
  }
}
